import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsTimeTrackingReportRoute: InvariantJiraRoute = {
	name: 'legacy-reports-time-tracking-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:time-tracking'],
};
